// extracted by mini-css-extract-plugin
export default {"sold-out-text":"lGOD+O-16M59-jiiBAfAoQ=="};